import {defineComponent} from "vue";
import IntegrationDetail from './detail.vue';
import Marketplace from './marketplace.vue';
import {SoftwarePartner} from "../../types/dto/SoftwarePartner";
import Gallery from '../../components/gallery.vue';
import {createVueInstance} from "../../vue-root";

const comp = defineComponent({
    name: 'integrations-page',
    components: { 
        IntegrationDetail,
        Gallery,
        Marketplace
    },
    data() {
        return {
            images: ((window.cw.integration as SoftwarePartner)?.screenshots ?? []) as string[],
            index: null
        }
    }
});
createVueInstance(comp);
